var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4405 10.8984C22.0405 11.2084 23.5105 13.0584 23.5105 17.1084V17.2384C23.5105 21.7084 21.7205 23.4984 17.2505 23.4984H10.7405C6.27047 23.4984 4.48047 21.7084 4.48047 17.2384V17.1084C4.48047 13.0884 5.93047 11.2384 9.47047 10.9084",
    stroke: "url(#paint0_linear_7404_66013)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7505 4C14.7505 3.58579 14.4147 3.25 14.0005 3.25C13.5863 3.25 13.2505 3.58579 13.2505 4V16.1894L11.1807 14.1197C10.8878 13.8268 10.413 13.8268 10.1201 14.1197C9.82717 14.4126 9.82717 14.8874 10.1201 15.1803L13.4701 18.5303C13.763 18.8232 14.2378 18.8232 14.5307 18.5303L17.8807 15.1803C18.1736 14.8874 18.1736 14.4126 17.8807 14.1197C17.5878 13.8268 17.113 13.8268 16.8201 14.1197L14.7505 16.1892V4Z",
    fill: "url(#paint1_linear_7404_66013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7404_66013",
    x1: 13.9955,
    y1: 3.80072,
    x2: 0.291865,
    y2: 22.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7404_66013",
    x1: 14.0004,
    y1: -5.48131,
    x2: 0.467662,
    y2: 0.873309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1374a9a3e4ad9ba69b84c90b3ce3abeb.svg";
export { ForwardRef as ReactComponent };